/** Pixel height of one 30-minute row — shared by schedule-step, calendars, booking. */
export const SLOT_ROW_HEIGHT = 30;

/**
 * Weekly schedule convention (ISO / Spanish business week).
 * `weeklyHours[i]`, `fixedBlocks[].day`, and calendar grids all use this index:
 * 0 = Lunes … 6 = Domingo. Month/week calendars start on Monday (LU).
 */
export const WEEK_STARTS_ON_MONDAY = true as const;
export const WEEKDAY_INDEX_MON = 0;
export const WEEKDAY_INDEX_SUN = 6;

/** Short labels aligned with `weeklyHours` indices (Mon → Sun). */
export const WEEKDAY_LABELS_SHORT = ['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab', 'Dom'] as const;

/** @deprecated Prefer {@link WEEKDAY_LABELS_SHORT} — kept for existing imports. */
export const DAYS_SHORT = WEEKDAY_LABELS_SHORT;

export const MONTH_NAMES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
] as const;

/** Max booking horizon from today (calendar months). */
export const BOOKING_MAX_MONTHS = 6;
